import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const Enfoque = () => {
  const { t } = useLang();
  const items = t.approach.items;
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="relative bg-[#F7F8FA] py-24 md:py-36 border-t border-[#E4E7ED]"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 md:mb-20 items-end">
          <div className="lg:col-span-7">
            <p className="text-[11px] tracking-[0.35em] uppercase text-[#6F2DBD] font-semibold mb-6 flex items-center gap-3">
              <span className="inline-block w-10 h-px bg-[#6F2DBD]" />
              {t.approach.overline}
            </p>
            <h2 className="font-display text-[#002B6B] text-4xl md:text-5xl lg:text-6xl leading-[1.02] uppercase">
              {t.approach.title}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg text-[#6B7280] font-editorial font-light leading-relaxed">
              {t.approach.lead}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-px bg-[#E4E7ED] border border-[#E4E7ED]">
          {items.map((it, i) => (
            <motion.div
              key={it.verb}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`approach-${i}`}
              className="group bg-white px-6 md:px-7 py-10 md:py-12 flex flex-col justify-between min-h-[260px] transition-colors duration-500 hover:bg-[#002B6B]"
            >
              <div>
                <span className="text-[11px] tracking-[0.3em] uppercase text-[#6F2DBD] font-semibold group-hover:text-[#B89DDE]">
                  {it.tag}
                </span>
                <h3 className="font-display text-[#002B6B] text-2xl md:text-3xl mt-4 leading-tight uppercase group-hover:text-white transition-colors">
                  {it.verb}
                </h3>
              </div>
              <p className="text-sm text-[#6B7280] font-light leading-relaxed mt-6 group-hover:text-white/85 transition-colors">
                {it.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Enfoque;
